/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ApptStatusDetailApi } from '../api/apptstatusdetail.api';
import { switchMap, map } from 'rxjs/operators';
import { AppointmentStatusData, AppointmentStatusDetail } from '../../../interfaces/patient-services/appointment-status-detail';

@Injectable()
export class ApptStatusDetail extends AppointmentStatusData {

  constructor(private api: ApptStatusDetailApi) {
    super();
  }



  getById(url:string): Observable<AppointmentStatusDetail>{
      return this.api.getById(url);
  }

  create(url: string, data:AppointmentStatusDetail): Observable<AppointmentStatusDetail> {
    return this.api.add(url,data);
  }


}
